import type { OperationContext } from 'urql';

// The access token stays in the HTTP-only NextAuth session, never in browser JS.
export const favoriteRequestContext: Partial<OperationContext> = {
  url: '/api/favorites',
  preferGetMethod: false,
  fetchOptions: { credentials: 'same-origin' },
};
